import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Send } from 'lucide-react';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
export function Contact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setForm({
        name: '',
        email: '',
        message: ''
      });
    }, 5000);
  };
  return <div className="w-full bg-sand min-h-screen pt-24" data-id="element-415">
      <section className="py-20 px-4 max-w-7xl mx-auto" data-id="element-416">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-417">
          {/* Info Side */}
          <motion.div {...fadeIn} data-id="element-418">
            <h1 className="text-4xl md:text-5xl font-serif text-navy mb-6" data-id="element-419">
              Let's Connect
            </h1>

            <div className="prose prose-lg text-navy/70 font-light mb-12" data-id="element-420">
              <p data-id="element-421">
                <strong data-id="element-422">Our Philosophy:</strong> We don't chase. We don't
                pressure. We believe in providing exceptional value, curated
                insights, and unparalleled service.
              </p>
              <p className="italic text-gold mt-4" data-id="element-423">
                "When you're ready, we're ready."
              </p>
            </div>

            <div className="space-y-6" data-id="element-424">
              <div className="flex items-start" data-id="element-425">
                <MapPin className="text-gold mr-4 mt-1" size={24} data-id="element-426" />
                <div data-id="element-427">
                  <h4 className="font-serif text-navy text-lg" data-id="element-428">Office</h4>
                  <p className="text-navy/60 font-light" data-id="element-429">
                    Cabo San Lucas, BCS, Mexico
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-430">
                <Phone className="text-gold mr-4 mt-1" size={24} data-id="element-431" />
                <div data-id="element-432">
                  <h4 className="font-serif text-navy text-lg" data-id="element-433">Phone</h4>
                  <p className="text-navy/60 font-light" data-id="element-434">+1 (555) 123-4567</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-435">
                <Mail className="text-gold mr-4 mt-1" size={24} data-id="element-436" />
                <div data-id="element-437">
                  <h4 className="font-serif text-navy text-lg" data-id="element-438">Email</h4>
                  <p className="text-navy/60 font-light" data-id="element-439">
                    hello@cabocollection.com
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Form Side */}
          <motion.div {...fadeIn} transition={{
          delay: 0.2
        }} className="bg-white p-8 md:p-10 shadow-sm" data-id="element-440">
            {submitted ? <div className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-441">
                <Send className="text-gold mb-6" size={48} data-id="element-442" />
                <h3 className="text-2xl font-serif text-navy mb-2" data-id="element-443">
                  Message Received
                </h3>
                <p className="text-navy/70 font-light" data-id="element-444">
                  Thank you for reaching out. We will get back to you shortly.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-445">
                <div data-id="element-446">
                  <label className="block text-xs font-semibold text-navy uppercase tracking-wider mb-2" data-id="element-447">
                    Name
                  </label>
                  <input type="text" required value={form.name} onChange={e => setForm({
                ...form,
                name: e.target.value
              })} className="w-full px-4 py-3 bg-sand border border-navy/10 focus:outline-none focus:border-gold font-light" data-id="element-448" />
                </div>
                <div data-id="element-449">
                  <label className="block text-xs font-semibold text-navy uppercase tracking-wider mb-2" data-id="element-450">
                    Email
                  </label>
                  <input type="email" required value={form.email} onChange={e => setForm({
                ...form,
                email: e.target.value
              })} className="w-full px-4 py-3 bg-sand border border-navy/10 focus:outline-none focus:border-gold font-light" data-id="element-451" />
                </div>
                <div data-id="element-452">
                  <label className="block text-xs font-semibold text-navy uppercase tracking-wider mb-2" data-id="element-453">
                    How can we help?
                  </label>
                  <textarea required rows={5} value={form.message} onChange={e => setForm({
                ...form,
                message: e.target.value
              })} className="w-full px-4 py-3 bg-sand border border-navy/10 focus:outline-none focus:border-gold font-light resize-none" data-id="element-454"></textarea>
                </div>
                <button type="submit" className="w-full bg-navy text-white py-4 uppercase tracking-wider text-sm font-semibold hover:bg-navy-light transition-colors" data-id="element-455">
                  Send Message
                </button>
              </form>}
          </motion.div>
        </div>
      </section>
    </div>;
}